import FileUploadButton from '@/components/FileUploadButton'
import SelectMembers from '@/components/SelectMembers'
import DatePicker from '@/components/DatePicker'
import { deepCopy, objs2ids, validateExamDate, xlsxToJSON } from '@/utils/utils.format'
import Multiselect from 'vue-multiselect'
import { PROCTORING } from '@/config'

export default {
  components: {
    FileUploadButton,
    SelectMembers,
    Multiselect,
    DatePicker
  },
  data () {
    return {
      commission: [],
      papersFile: null,
      errors: [],
      proctoringOptions: PROCTORING
    }
  },
  methods: {
    checkForm () {
      this.errors = []
      const { exam } = this

      if (!(exam.start && exam.end && exam.name && exam.timing)) {
        this.errors.push(this.$t('baseExamForm.error.FIELD_REQUIRED'))
      }

      if (!exam.proctoring) {
        this.errors.push(this.$t('baseExamForm.error.PROCTORING_REQUIRED'))
      }

      if (!exam.commission_members.length) {
        this.errors.push(this.$t('baseExamForm.error.COMMISSION_REQUIRED'))
      }

      if (!validateExamDate(exam.start, exam.end)) {
        this.errors.push(this.$t('baseExamForm.error.INVALID_DATETIME'))
      }

      if (this.papersRequired && !this.papersFile) {
        this.errors.push(this.$t('baseExamForm.error.PAPERS_REQUIRED'))
      }

      return !this.errors.length
    },
    processForm () {
      return new Promise((resolve, reject) => {
        const examCopy = deepCopy(this.exam)
        examCopy.commission_members = objs2ids(this.exam.commission_members)

        return xlsxToJSON(this.papersFile)
          .then(papers => {
            resolve([examCopy, papers])
          })
          .catch(error => reject(error))
      })
    },
    submit () {
      const formValid = this.checkForm()

      if (formValid) {
        this.processForm()
          .then(([examData, papers]) => {
            this.afterProcessed(examData, papers)
          })
          .catch(() => this.$awn.alert(this.$t('baseExamForm.awn.PROCESSING_FAILURE')))
      }
    },
    sendPapers (exam, papers) {
      papers.forEach(paper => {
        paper.exam = exam.id
      })

      const papersPromise = this.uploadPapers({ examId: exam.id, papers })
      this.$awn.async(
        papersPromise,
        this.onPapersSuccess,
        this.onPapersFailure,
        this.$t(`${this.prefix}.awn.SEND_PAPERS`)
      )
    },
    getProctoringLabel (option) {
      switch (option) {
        case 'online':
          return this.$t('baseExamForm.ONLINE_PROC')
        case 'offline':
          return this.$t('baseExamForm.OFFLINE_PROC')
        case 'identification':
          return this.$t('baseExamForm.IDENTIFICATION_PROC')
        case 'auto':
          return this.$t('baseExamForm.AUTO_PROC')
      }
      return 'UNKNOWN'
    }
  }
}
